export default {
  computed: {
    usersQuickFiltersCarriers() {
      return {
        title: 'Users',
        filters: {
          columns: [
            {
              class: 'col-12 col-md-2',
              filters: [
                {
                  name: 'roles',
                  label: this.$gettext('Roles'),
                  type: 'checkbox-group',
                  options: this.appRolesTranslated,
                  value: [],
                  stacked: true,
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'roles.id', 'in', val ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-md-5',
              filters: [
                {
                  name: 'user-id',
                  label: this.$gettext('User ID'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'id', 'eq', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'user-name',
                  label: this.$gettext('Name'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'name', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'user-tin',
                  label: this.$gettext('User TIN'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'tin', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-md-5',
              filters: [
                {
                  name: 'user-email',
                  label: this.$gettext('Email'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'email', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'user-phone',
                  label: this.$gettext('Phone'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'phone', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  columns: [
                    {
                      class: 'col-6',
                      filters: [
                        {
                          name: 'user-enabled',
                          label: this.$gettext('User Status'),
                          type: 'radio-group',
                          options: [
                            {
                              text: this.$gettext('All'),
                              value: null
                            },
                            {
                              text: this.$gettext('Enabled'),
                              value: 1
                            },
                            {
                              text: this.$gettext('Disabled'),
                              value: false
                            }
                          ],
                          value: null,
                          stacked: true,
                          callback: (val) => {
                            if (val === 1) {
                              return [[ 'active', 'eq', 1 ]]
                            } else if (val === false) {
                              return [[ 'active', 'eq', false ]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    },
                    {
                      class: 'col-6',
                      filters: [
                        {
                          name: 'user-active',
                          label: this.$gettext('Online/Offline'),
                          type: 'radio-group',
                          options: [
                            {
                              text: this.$gettext('All'),
                              value: null
                            },
                            {
                              text: this.$gettext('ONline'),
                              value: 1
                            },
                            {
                              text: this.$gettext('OFFline'),
                              value: 0
                            }
                          ],
                          value: null,
                          stacked: true,
                          callback: (val) => {
                            if (val === 1) {
                              return [['courier_available.active', 'eq', 1]]
                            } else if (val === 0) {
                              return [['courier_available.active', 'eq', 0]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    }
  }
}
